import { ReactComponent as IconMemberSolid } from '../icons/IconMemberSolid.svg'
import { ReactComponent as IconMemberHollow } from '../icons/IconMemberHollow.svg'
import { ReactComponent as IconMemberColdFormed } from '../icons/IconMemberColdFormed.svg'
import { ReactComponent as IconMemberWideFlange } from '../icons/IconMemberWideFlange.svg'
import { ReactComponent as IconMemberMetalDeck } from '../icons/IconMemberMetalDeck.svg'
import { ReactComponent as IconMemberRound } from '../icons/IconMemberRound.svg'
import { ReactComponent as IconMemberRoundHollow } from '../icons/IconMemberRoundHollow.svg'
import { ReactComponent as IconMemberZee } from '../icons/IconMemberZee.svg'
import { memberKind } from '../internalModules'

type Props = {
  kind: string,
  size?: number
}

export default function UILayerIcon({kind, size=36}: Props) {

  function showIcon(){
    switch (kind) {
      case memberKind.solidRect:
        return <IconMemberSolid height={size}/>
      case memberKind.hollowRect:
        return <IconMemberHollow height={size}/>
      case memberKind.coldFormed:
        return <IconMemberColdFormed height={size}/>
      case memberKind.wideFlange:
        return <IconMemberWideFlange height={size}/>
      case memberKind.metalDeck:
        return <IconMemberMetalDeck height={size}/>
      case memberKind.solidRound:
        return <IconMemberRound height={size}/>
      case memberKind.hollowRound:
        return <IconMemberRoundHollow height={size}/>
      case memberKind.zee:
        return <IconMemberZee height={size}/>
      default:
        return <></>
    }
  }

  return(
    <>
      {showIcon()}
    </>
  )
}